/**
 * Converte a resposta do endpoint `/api/parcerias/consulta-rapida/{rfid}`
 * (ou `/api/cliente/talao`) num formato uniforme para o componente <Talao>.
 */
export function mapearConsultaParaTalao(d) {
  if (!d) return null;
  // Aceita 2 estruturas: response do consulta-rapida OU /cliente/talao já mapeado.
  const cliente = d.cliente || {};
  const pontos = d.pontos || {};
  const cashback = d.cashback || {};

  // Vales (formato consulta-rapida: vales_ativos)
  const vales = (d.vales_ativos || d.vales || []).map(v => ({
    numero: v.numero_vale || v.numero || v.codigo || '',
    valor: v.valor || v.valor_desconto || 0,
    validade: v.data_validade_fmt || _fmtData(v.data_validade) || v.validade || '',
    parceria: v.parceria || v.nome_parceria || '',
  }));

  // Perfis benefício
  const perfis = (d.perfis_beneficio || []).map(p => ({
    nome: p.nome || '',
    regras_texto: (p.regras || [])
      .map(r => `${r.tipo_beneficio || ''} ${r.valor_beneficio ?? ''}`.trim())
      .filter(Boolean)
      .join(' · '),
  }));

  // Campanhas em vigor (a partir de campanhas_ativas)
  const campanhas = (d.campanhas_ativas || []).map(c => ({
    nome: c.nome || '',
    tipo: c.tipo || (c.cashback_valor_fixo ? 'Cashback' : (c.pontos_multiplicador ? 'Pontos' : '')),
    descricao: c.descricao || '',
    acumular_de: c.inicio_acum || '',
    acumular_ate: c.fim_acum || '',
    resgatar_de: c.inicio_resgate || '',
    resgatar_ate: c.fim_resgate || '',
    minimo_compra: c.minimo_compra_acumular || c.minimo_compra_resgatar || 0,
  }));

  // Bónus adesão (a partir de ciclo_fidelizacao se ativo)
  let bonusAdesao = null;
  const ciclo = d.ciclo_fidelizacao || cliente.ciclo_fidelizacao;
  if (ciclo && ciclo.estado === 'bonus_ativo' && (ciclo.bonus_atual || ciclo.bonus_valor)) {
    bonusAdesao = {
      valor: ciclo.bonus_atual || ciclo.bonus_valor || 5,
      expira_em: ciclo.bonus_expira ? _fmtData(ciclo.bonus_expira) : null,
      minimo_compra: ciclo.compra_minima || 25,
    };
  }

  return {
    cliente: {
      nome: cliente.nome || cliente.nome_cliente || d.nome || '',
      id_cartao_rfid: cliente.id_cartao_rfid || d.id_cartao_rfid || '',
      nif: cliente.nif || '',
      tel: cliente.telemovel || cliente.telefone || '',
      tipo: cliente.tipo_registo || cliente.tipo || '',
    },
    pontos: {
      saldo: pontos.saldo ?? d.saldo_pontos ?? 0,
      valor_euro: pontos.valor_em_euros ?? pontos.valor_euro ?? d.valor_pontos_euro ?? 0,
      minimo_resgate: pontos.minimo_resgate ?? d.minimo_resgate,
      validade: pontos.validade,
    },
    cashback: {
      saldo: cashback.saldo ?? d.saldo_cashback ?? 0,
      saldo_resgatavel: cashback.saldo_resgatavel,
      motivo_bloqueio: cashback.motivo_bloqueio,
      bonus_adesao: bonusAdesao,
    },
    vales,
    perfis_beneficio: perfis,
    campanhas_em_vigor: campanhas,
  };
}

function _fmtData(d) {
  if (!d) return '';
  try {
    const dt = typeof d === 'string' ? new Date(d) : d;
    if (isNaN(dt)) return d;
    return dt.toLocaleDateString('pt-PT');
  } catch {
    return String(d);
  }
}
